<template>
  <div class="card-container">
    <common-top-form
      selectShowPower="/receivedetail/select"
      :model="formModel"
      buttonName="调账"
      addShowPower="/receivedetail/tiaozhang"
      @openAddDialog="openDialog"
      :submitService="submitService"
      :submitData="submitData"
      @success="onSuccess"
      buttonType="warning"
      :showDownloadPower="true"
      showDownloadPowerType="purple"
      downloadPowerText="合计"
      downloadPower="/receivedetail/tatAssets"
      @down="down"
    >
      <el-form-item label="订单号">
        <el-input
          style="width: 330px"
          v-model="formModel.odrId"
          maxlength="50"
          placeholder="请输入订单号"
        ></el-input>
      </el-form-item>
      <el-form-item label="交易类型">
        <el-select v-model="formModel.tranType" filterable>
          <el-option
            v-for="item in tranTypes"
            :key="item.dictKey"
            :label="item.dictValue"
            :value="item.dictKey"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="业务类型">
        <el-select v-model="formModel.busiType" filterable>
          <el-option
            v-for="item in busiTypes"
            :key="item.dictKey"
            :label="item.dictValue"
            :value="item.dictKey"
          >
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="操作类型">
        <el-select v-model="formModel.optType">
          <el-option
            v-for="item in optTypes"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="变更日期">
        <el-date-picker
          v-model="formModel.time"
          type="daterange"
          range-separator="至"
          value-format="yyyy-MM-dd"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
      </el-form-item>
      <!-- 新增机构 -->
      <el-form-item
        label="机构名称"
        prop="activityName"
        v-if="this.textTatSimpleId"
      >
        <el-select style="width: 198px" v-model="formModel.tatSimpleId" filterable>
          <el-option
            v-for="item in typeTwo"
            :key="item"
            :label="item.tatName"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
    </common-top-form>
    <common-table :data="tableData" ref="commonTable" @handleChange="getPage">
      <el-table-column
        prop="tatSimpleName"
        label="机构名称"
        min-width="120"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="tranType"
        label="交易类型"
        min-width="100"
        :formatter="formatTranTypee"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="busiType"
        label="业务类型"
        min-width="100"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="odrId"
        label="订单号"
        min-width="330"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="optType"
        label="操作类型"
        min-width="100"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <p>
            {{ scope.row.optType == 1 ? "加" : "减" }}
          </p>
        </template>
      </el-table-column>
      <el-table-column
        prop="odrAmt"
        label="变动金额（元）"
        min-width="130"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <p>{{ toDoubleThousands((scope.row.odrAmt * 100) / 10000) }}</p>
        </template>
      </el-table-column>
      <el-table-column
        prop="balAmt"
        label="变动后余额（元）"
        min-width="150"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <p>{{ toDoubleThousands((scope.row.balAmt * 100) / 10000) }}</p>
        </template>
      </el-table-column>
      <el-table-column
        prop="createTime"
        label="变动时间"
        min-width="160"
      ></el-table-column>
      <el-table-column
        prop="remark"
        label="备注"
        min-width="160"
        :formatter="formatterTableData"
      ></el-table-column>
    </common-table>
    <show-info-dialog
      title="合计"
      :show="true"
      ref="showInfoDialog"
      dialogWidth="400px"
      class="showInfoDialog"
    >
      <div>
        <p>变动金额：{{ dialogObj }}元</p>
      </div>
    </show-info-dialog>
    <form-dialog
      ref="formDialog"
      formDialogTitle="调账"
      :model="dialogModel"
      :submitData="dialogData"
      :rules="dialogRules"
      :dialogService="dialogService"
      @close="dialogClose"
      @success="dialogSuccess"
    >
      <el-form-item label="调账类型" prop="adjustType">
        <el-select v-model="dialogModel.adjustType">
          <el-option
            v-for="item in bbbbusiTypes"
            :key="item.dictKey"
            :label="item.dictValue"
            :value="item.dictKey"
            placeholder="请选择"
          >
          </el-option>
        </el-select>
      </el-form-item>
        <el-form-item label="机构调账" prop="tatSimpleId" v-if="dialogModel.adjustType == 2" >
        <el-select v-model="dialogModel.tatSimpleId" filterable>
          <el-option
            v-for="item in typeAdd"
            :key="item"
            :label="item.tatName"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        label="业务类型"
        prop="operation"
        v-if="dialogModel.adjustType == 2 || dialogModel.adjustType == 3"
      >
        <el-select v-model="dialogModel.operation">
          <el-option
            placeholder="请选择"
            v-for="item in busiTypes.slice(1, busiTypes.length)"
            :key="item.dictKey"
            :label="item.dictValue"
            :value="item.dictKey"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        label="交易类型"
        prop="operation"
        v-if="
          dialogModel.adjustType == 4 ||
          dialogModel.adjustType == 5 ||
          dialogModel.adjustType == 6 ||
          dialogModel.adjustType == 7
        "
      >
        <el-select v-model="dialogModel.operation">
          <el-option
            placeholder="请选择"
            v-for="item in shanghuTypes"
            :key="item.dictKey"
            :label="item.dictValue"
            :value="item.dictKey"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        v-if="
          dialogModel.adjustType == 3 ||
          dialogModel.adjustType == 6 ||
          dialogModel.adjustType == 7 || 
            dialogModel.adjustType == 2
        "
        label-width="90px"
        label=" "
        prop="operationDirection"
      >
        <el-radio-group v-model="dialogModel.operationDirection">
          <el-radio :label="1">加</el-radio>
          <el-radio :label="2">减</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item
        label="账户类型"
        prop="accType"
        v-if="
          dialogModel.adjustType == 1 ||
         
          dialogModel.adjustType == 3
        "
      >
        <el-select v-model="dialogModel.accType">
          <el-option
            placeholder="请选择"
            v-for="item in accType"
            :key="item.dictKey"
            :label="item.dictValue"
            :value="item.dictKey"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item
      v-if="dialogModel.adjustType != 2"
        :label="
          dialogModel.adjustType == 1 ||
         
          dialogModel.adjustType == 3
            ? '代理商ID'
            : dialogModel.adjustType == 4 ||
              dialogModel.adjustType == 5 ||
              dialogModel.adjustType == 6
            ? '商户编号'
            : dialogModel.adjustType == 7
            ? '用户ID'
            : '代理商ID'
        "
        prop="memId"
      >
        <el-input
          type="textarea"
          v-model="dialogModel.memId"
          rows="5"
          placeholder="请输入，多个‘,’分割"
        ></el-input>
      </el-form-item>
      <el-form-item label="调账金额" prop="adjustAmt">
        <el-input-number
          placeholder="请输入"
          v-model="dialogModel.adjustAmt"
          :controls="false"
          controls-position="right"
          :precision="2"
          :step="0.1"
          :min="0"
        ></el-input-number>
        <span>元</span>
      </el-form-item>
      <el-form-item label="备注" style="width: 360px">
        <el-input
          maxlength="300"
          show-word-limit
          type="textarea"
          resize="none"
          rows="5"
          placeholder="请输入备注"
          v-model="dialogModel.remark"
        ></el-input>
      </el-form-item>
    </form-dialog>
  </div>
</template>

<script>
import CommonTopForm from "components/common/CommonTopForm";
import CommonTable from "components/common/CommonTable";
import ShowInfoDialog from "../../dialog/ShowInfoDialog";
import FormDialog from "@/view/dialog/FormDialog";

import LYFAcctTypes from "service/constant/LYFAcctTypes";
import FinanceService from "service/FinanceService";
import StatisticsService from "service/StatisticsService";
import privateKey from "service/constant/privateKey";
import { encrypt, urlEncode, objKeySort } from "common/js/common-utils";
import { loadMixin, dialogMixin } from "mixin";
import activity from "service/Ainstitution";
import { mapGetters } from "vuex";

export default {
  name: "receivedetail",
  components: {
    CommonTopForm,
    CommonTable,
    ShowInfoDialog,
    FormDialog,
  },
  data() {
    return {
         typeAdd: [],
      dialogModel: {
        adjustType: "",
        operation: "",
        accType: "",
        adjustAmt: undefined,
        memId: "",
        remark: "",
        operationDirection: 1,
        tatSimpleId:""
      },
      formModel: {
        tranType: "",
        optType: "",
        busiType: "",
        odrId: "",
        time: [],
        tatSimpleId: "",
      },
      dialogRules: {
        adjustType: [
          {
            required: true,
            message: "请选择",
          },
        ],
        operation: [
          {
            required: true,
            message: "请选择",
          },
        ],
          tatSimpleId: [
          {
            required: true,
            message: "请选择",
          },
        ],
        accType: [
          {
            required: true,
            message: "请选择",
          },
        ],
        memId: [
          {
            required: true,
            message: "请输入",
          },
        ],
        adjustAmt: [
          {
            required: true,
            message: "请输入",
          },
        ],
      },
      all: [
        {
          id: "",
          simpleName: "全部",
        },
      ],
      bbbbusiTypes: [],
      // bbbbusiTypes: [
      //   {
      //     dictKey: "1",
      //     dictValue: "代理商到机构",
      //   },
      //   {
      //     dictKey: "2",
      //     dictValue: "到代理商",
      //   },
      //   {
      //     dictKey: "3",
      //     dictValue: "只到代理商",
      //   },
      //   {
      //     dictKey: "4",
      //     dictValue: "商户到机构",
      //   },
      //   {
      //     dictKey: "5",
      //     dictValue: "到商户",
      //   },
      //   {
      //     dictKey: "6",
      //     dictValue: "只到商户",
      //   },
      //   {
      //     dictKey: "7",
      //     dictValue: "只到个人",
      //   },
      // ],
      accType: LYFAcctTypes,
      busiTypes: [],
      tableData: [],
      page: {},
      params: {},
      optTypes: [
        {
          value: "",
          label: "全部",
        },
        {
          value: "1",
          label: "收入（+）",
        },
        {
          value: "2",
          label: "支出（-）",
        },
      ],
      tranTypes: [],
      shanghuTypes: [],
      submitService: FinanceService.getTatAccDtl,
      isPage: false,
      dialogObj: {},
      typeTwo: [{ tatName: "全部", id: "" }],
    };
  },
  mixins: [loadMixin, dialogMixin],
  mounted() {
    this.getTypeNames("交易类型", (res) => {
      this.tranTypes = [
        {
          dictKey: "",
          dictValue: "全部",
        },
        ...res,
      ];
    });
      this.getTypeNames("调账类型", (res) => {
      this.bbbbusiTypes = res;
    });
    this.getTypeNames("商户交易类型", (res) => {
      this.shanghuTypes = res;
    });
    this.getTypeNames("业务类型", (res) => {
      this.busiTypes = [
        {
          dictKey: "",
          dictValue: "全部",
        },
        ...res,
      ];
    });
    this.load();
  },
  computed: {
    submitData() {
      if (this.formModel.time == null || this.formModel.time == "") {
        this.formModel.time = [];
      }
      this.params = {
        userId: this.userId,
        odrId: this.formModel.odrId.trim(),
        tranType: this.formModel.tranType,
        busiType: this.formModel.busiType,
        optType: this.formModel.optType,
        startDate: this.formModel.time[0],
        endDate: this.formModel.time[1],
        current: this.isPage ? this.page.currentPage : 1,
        size: this.page.pageSize,
      };
      if (this.textTatSimpleId) {
        this.params.tatSimpleId = this.formModel.tatSimpleId;
      }
      if (this.formModel.time.length == 0) {
        delete this.params.startDate;
        delete this.params.endDate;
      }

      return this.params;
    },
    dialogData() {
      const params = {
        adjustType: this.dialogModel.adjustType,
        operation: this.dialogModel.operation,
        // accType: this.dialogModel.accType,
        adjustAmt: this.dialogModel.adjustAmt,
        remark: this.dialogModel.remark,
        // memId: this.dialogModel.memId,
      };
      if(this.dialogModel.adjustType != 2) {
         params.accType = this.dialogModel.accType;
          params.memId = this.dialogModel.memId;
      }
      if (
        this.dialogModel.adjustType == 3 ||
        this.dialogModel.adjustType == 6 ||
        this.dialogModel.adjustType == 7 || 
        this.dialogModel.adjustType == 2
      ) {
        params.operationDirection = this.dialogModel.operationDirection;
      }
      if(this.dialogModel.adjustType == 2) {
        params.tatSimpleId = this.dialogModel.tatSimpleId
      }
      return params;
    },
    dialogService() {
      return FinanceService.receivedetailTiaoz;
    },
    ...mapGetters(["serverType", "tatId", "userId", "textTatSimpleId"]),
  },
  methods: {
    load() {
      this.page = this.$refs.commonTable.page;
      this.getList();
      this.getTypeTwo();
    },
    getTypeTwo() {
      this.doLoad(
        activity.signList,
        {
          size: 9999,
        },
        (res) => {
          this.doCheck(res, (res) => {
            res.contents.rows.forEach((item) => {
              (item.dictValue = item.id), (item.dictKey = item.tatName);
            });
            this.typeTwo = [...this.typeTwo, ...res.contents.rows];
                this.typeAdd = [...this.typeAdd, ...res.contents.rows];
                this.tableData.forEach((item) => {
              this.typeTwo.forEach((itemTwo) => {
                if (item.tatSimpleId == itemTwo.dictValue) {
                  item.tatSimpleName = itemTwo.dictKey;
                }
              });
            });
            console.log(this.typeTwo,'this.typeWww')
         
            console.log(this.tableData, "this.table");
          
          });
        },
        "信息获取失败"
      );
    },
    openDialog(item) {
      this.$refs.formDialog.open();
    },
    down() {
      this.doLoad(
        FinanceService.sumTatAccDtl,
        this.submitData,
        (res) => {
          this.doCheck(res, (res) => {
            const result = res.contents;
            this.dialogObj = result;
            this.$nextTick(() => {
              this.$refs.showInfoDialog.open();
            });
          });
        },
        "信息获取失败"
      );
    },
    formatTranTypee(row, column, cellValue) {
      let value = "";
      this.tranTypes.forEach((item) => {
        if (item.dictKey == cellValue) {
          value = item.dictValue;
        }
      });
      return value ? value : "--";
    },
    exportInfo() {
      this.limitExport(this.page.total)
        ? StatisticsService.exportExcel(
            this.submitData,
            "tatAcctDtlExport",
            "",
            "/fin/"
          )
        : "";
    },
    getPage() {
      this.isPage = true;
      this.getList();
    },
    getList() {
      this.doLoad(
        FinanceService.getTatAccDtl,
        this.submitData,
        (res) => {
           this.tableData.forEach((item) => {
              this.typeTwo.forEach((itemTwo) => {
                if (item.tatSimpleId == itemTwo.dictValue) {
                  item.tatSimpleName = itemTwo.tatName;
                } else if (!item.tatSimpleId) {
                  item.tatSimpleName = "--";
                }
              });
            });
          // 测试一下
          this.doCheck(res, (res) => {
            this.onSuccess(res);
            this.isPage = false;
          });
        },
        "信息获取失败"
      );
    },
    dialogClose() {
      this.dialogModel = {
        adjustType: "",
        operation: "",
        accType: "",
        adjustAmt: undefined,
        memId: "",
        remark: "",
        operationDirection: 1,
      };
    },
    dialogSuccess(res) {
      this.commonSuccess(res);
      this.$refs.formDialog.closeDialog();
    },
    commonSuccess(res) {
      this.showSuccess(res.respMsg);
      this.getList();
    },
    onSuccess(res) {
      this.doCheck(res, (res) => {
        const result = res.contents;
        this.tableData = result.rows;
        this.page.currentPage = result.current;
        this.page.pageSize = result.size;
        this.page.total = result.total;
         this.tableData.forEach((item) => {
              this.typeTwo.forEach((itemTwo) => {
                if (item.tatSimpleId == itemTwo.dictValue) {
                  item.tatSimpleName = itemTwo.dictKey;
                }
              });
            });
      });
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/view/page/Transaction/ReceiveDetail.vue